module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAOCAYAAAA8E3wEAAABQUlEQVQ4T9WT3SpEURTHf+tM8nGHFFd4A6Q8gsmFvILSMVOUuWEiTZNozM0oasZJeQW5EI+ghDfAFSXc+Uhzlpw09syZOWc0dcq622v/9/+31mptIeKQiHn8A6CtY8D6z2Q2cOTyL1NqvsOU9vDKJmCjWB5EcAGHLtYoyHMz4HBgRi3umUPYQumtayo8oawywAFZ+S6iYQQDbZ1A2EMZr3IQTryzMlWTv0BZwJHzRsT6wEXt44McMOsN7jduiLFEUY69VFKnKbMDDBsaBQ5pJ82uPNaC/cCkdlPmChisiIU3IEc/ebLyXmWS0Q4eWAbSKJ3G3R0xRinKi6n3AxM6icupITrCIkVJbgOXIqFDuBSAmYrOIk5JzoKBtrYB28AIQp59MeHhizivcdTr+BpYwZHPYGC4ZUuK8G/Rkr3/ceTAL8EYTg8iGC/aAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-up.png
// module id = inxr
// module chunks = 167